<template>
  <div class="page-not-found-wrapper overlay">
    <el-row
      align="center"
      type="flex"
      justify="center"
      class="flex-full flex-column-items"
    >
      <div class="page-not-found paflex-full-xs text-center">
        <h1>{{ $t('using-adblock.title') }}</h1>
        <p>{{ $t('using-adblock.description') }}</p>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// src/components/UsingAdBlock.vue